import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import Header from '../../common_components/Header';
import Footer from '../../common_components/Footer';
import Drawer from '../../common_components/Drawer';
import {

} from '../../actions/registration_action'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from '../../utils/withRouter';
import moment from 'moment';
import ConfirmationModal from "../../common_components/confirmationa_modal";
import AdminHeader from '../../common_components/admin_module_header';
import Modal from "react-modal";
import Loader from '../../utils/Loader'
import { sendPaymentForm_action } from "../../actions/payment_action/payment_action";
import { clearSessionStorage, countryActionId, paymentPortalLink, paymentAccessCode, surchargeListActionId, toastError, toastSuccess, downloadReport, paymentMasterListActionId, DOC_BASE_URL } from '../../utils/constants'
import Pagination from '../../utils/pagination'
import { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { fill_action } from '../../actions/fillCombo_action';
import { lastSubmitAdd_action } from "../../actions/last_submit_action";
import {
    getdescriptionDetails_action, descriptionAdd_action, descriptionUpdate_action,
    getdescriptionTermsAndCondition_action, descriptionPreview_action,
} from '../../actions/description_action'
import {
    getPendingRegDetails_action
} from '../../actions/registration_action'
import StepHeader from './stepHeader';
import $ from 'jquery'
import {
    contactNoValidator,
    panNoValidator,
    tanNoValidator,
    gstNoValidator,
    emailValidator,
} from "../../utils/Validator";

import "pdfjs-dist/build/pdf.worker.entry";
import { BASE_URL } from "../../utils/constants";
import * as pdfjsLib from "pdfjs-dist";

/* 
 * mapDispatchToProps
*/
// const mapDispatchToProps = dispatch => ({
//     loginAction: () => dispatch(loginAction())
// })

/* 
 * mapStateToProps
*/
const mapStateToProps = state => ({
    ...state
})

class Description extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            confirmationObj: { message: '', buttonName: '', action: '' },
            popArg: [],
            isOpenConfirmationModal: false,
            isDecscriptionUpdate: false,

            comment: '',
            commentErr: '',
            countryId: "",
            isChecBox1: false,
            isChecBox2: false,
            isChecBox3: false,
            isChecBox4: false,
            isChecBox5: false,
            isChecBox6: false,
            isChecBox7: false,
            estimateDescription: '',
            descriptionList: [],
            paymentList: [],
            undertakingNotes: [],
            exhRegistrationID: 0,
            exhibitionID: '',
            RandRpath: '',
            openPop1: false,
            openPop2: false,
            openPop5: false,
            openPop3: false,
            openPop4: false,
            openPaymentPop: false,
            remittancesInfavour: '',
            checkboxList: [],
            undertakingContent: [],
            AuthorizedPersonName: '',
            DesignationAuthorizedPerson: '',
            ExhibitorCompanyName: '',
            EmailAuthorizedPerson: '',
            MobileAuthorizedPerson: '',
            AuthorizedPersonNameErr: '',
            DesignationAuthorizedPersonErr: '',
            ExhibitorCompanyNameErr: '',
            EmailAuthorizedPersonErr: '',
            MobileAuthorizedPersonErr: '',
            PreMobileAuthorizedPerson: '',
            paymentLink: '',

            remark: '',
            toPay: '',
            toPaydummy: '',
            paymentType: 1,
            customPayment: '',
            isCustompayment: '',
            minPay: '',
            encPayload: '',
            isPaymentEnable: false,
            isDescripionCheckbox: false,
            isFlag1: false,
            isFlag3: false,
            isFlag4: false,
            isFlag5: false,
            isFlag6: false,
            isFlag7: true,

            pgViewChargesModal: false,
            pgViewChargesFillList: [],

            toShowIntNotes: false,
            isSurchargeForceOpen: true,
            isForeignPop: false,
            toShow: 0,
            conversionRate: '',
            isPaidByUSD: true,
            pgViewAddChargesModal: false,
            additionalChargesUSDper: 0,
            additionalChargesUSD: 0,
        }
        this.pdfContainerRef = createRef();
        this.submitfrm = React.createRef()
        this.getFillList = this.getFillList.bind(this)
        this.onPreviousClick = this.onPreviousClick.bind(this)
        this.onCheckBoxClick = this.onCheckBoxClick.bind(this)
        this.onCheckBox2Click = this.onCheckBox2Click.bind(this)
        this.maxLengthCheck = this.maxLengthCheck.bind(this)
        this.preventMinus = this.preventMinus.bind(this)
        this.onLinkbtn1Click = this.onLinkbtn1Click.bind(this)
        this.onLinkbtn1Click = this.onLinkbtn1Click.bind(this)
        this.onLinkbtn2Click = this.onLinkbtn2Click.bind(this)
        this.onLinkbtn3Click = this.onLinkbtn3Click.bind(this)
        this.onLinkbtn4Click = this.onLinkbtn4Click.bind(this)
        this.loadscript = this.loadscript.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
        this.onSubmitClick = this.onSubmitClick.bind(this)
        this.onPreviewClick = this.onPreviewClick.bind(this)
        this.getPendingRegDetailsByCode = this.getPendingRegDetailsByCode.bind(this)
        this.onPayAndSubmit = this.onPayAndSubmit.bind(this)
        this.onPaymentTypeSelect = this.onPaymentTypeSelect.bind(this)
        this.navPayment = this.navPayment.bind(this)
        this.togglePGCharges = this.togglePGCharges.bind(this)

        this.handleConfirmation = this.handleConfirmation.bind(this)
    }


    handleConfirmation(flag) {
        const { confirmationObj, popArg } = this.state;
        if (flag) {
            if (confirmationObj.action == 0) {
                this.onSendDescrpData(popArg.join(','))
            }
            if (confirmationObj.action == 1) {
                this.onSendDescrpData(popArg.join(','))
            }
            if (confirmationObj.action == 2) {
                this.onPayAndSubmit(popArg.join(','))
            }
        }
        this.setState({ isOpenConfirmationModal: false })
    }

    componentDidMount() {
        this.contextMenuHandler = (e) => e.preventDefault();
        document.addEventListener("contextmenu", this.contextMenuHandler);

        this.keyDownHandler = (e) => {
            if (
                e.keyCode === 123 || // F12
                (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74)) || // Ctrl+Shift+I/J
                (e.ctrlKey && e.keyCode === 85) // Ctrl+U
            ) {
                e.preventDefault();
                return false;
            }
        };
        document.addEventListener("keydown", this.keyDownHandler);

        console.log(sessionStorage.getItem('sessionExhibitionID'), !sessionStorage.getItem('sessionExhibitionID'), 'prop is :', this.props);
        // sessionStorage.getItem("sessionContryName",)
        //if pending link call.........................................
        var param = this.props.params != '' && Object.keys(this.props.params).length != 0 && this.props.params != undefined && this.props.params != null ? this.props.params : null
        var status = param != null ? param.id != undefined && param.id != '' && param.id != null ? param.id : null : null
        console.log(param, status)
        if (sessionStorage.getItem('sessionExhibitionID') != null) {
            if (this.props.location.pathname.includes('/description/') && status != 'Invalid' && status != 'Failure') {
                var code = this.props.location.pathname.replace('/description/', '');
                sessionStorage.setItem("renderPage", "description")
                this.getPendingRegDetailsByCode(code)
                this.loadscript()
            } else {
                sessionStorage.setItem("renderPage", "description")
                this.setState({
                    exhibitionID: sessionStorage.getItem("sessionExhibitionID"),
                    exhRegistrationID: sessionStorage.getItem("sessionExhRegistrationID"),
                    countryId: sessionStorage.getItem("countryId"),
                    PreMobileAuthorizedPerson: sessionStorage.getItem("countryId") == 91 ? '+91' : ''
                });
                this.getDescriptionDetails();
                this.loadscript()
            }
            setTimeout(() => {

                console.log('=====================>', status, Object.keys(this.props.params).length)
                if (status != null) {
                    if (status == 'Success') {
                        toastSuccess("Payment Successful")
                    } else if (status == 'Failure') {
                        toastError('Your payment has either been canceled or failed due to a technical issue. Please try again later or contact India ITME Society for assistance.')
                    } else if (status == 'Invalid') {
                        toastError('Payment for the order is already processed')
                    }
                }
            }, 500);
            console.log(sessionStorage.getItem("countryId"), sessionStorage.getItem("ExhRegistrationIDSS")
            )
        }

    }

    componentWillUnmount() {
        document.removeEventListener("contextmenu", this.contextMenuHandler);
        document.removeEventListener("keydown", this.keyDownHandler);
    }


    loadscript() {
        $(document).ready(function () {
            $(this).scrollTop(0);
        });
    }

    getPendingRegDetailsByCode(code) {
        console.log('code is : ', code);
        const { } = this.state

        this.setState({ isLoading: true });

        this.props
            .getPendingRegDetails_action(code)
            .then((data) => {
                if (data.error != 1) {
                    console.log('data is : ', data.data[0]);
                    console.log('ExhRegistrationID is : ', data.data[0].ExhRegistrationID);
                    sessionStorage.setItem("sessionExhibitionID", data.data.length > 0 ? data.data[0].ExhibitionID : '')
                    sessionStorage.setItem("sessionExhRegistrationID", data.data.length > 0 ? data.data[0].ExhRegistrationID : '')
                    sessionStorage.setItem("sessionContryNamePre", data.data.length > 0 ? data.data[0].CountryCode : '')
                    sessionStorage.setItem("isCountrySelected", true)
                    sessionStorage.setItem("isFirstStepCompleted", true)
                    sessionStorage.setItem("sessionContryName", data.data.length > 0 ? data.data[0].CountryName : '')
                    sessionStorage.setItem("countryId", data.data.length > 0 ? data.data[0].CountryID : '')




                    setTimeout(() => {
                        // this.setState({ isLoading: false })
                        this.setState({
                            exhibitionID: data.data.length > 0 ? data.data[0].ExhibitionID : '',
                            exhRegistrationID: data.data.length > 0 ? data.data[0].ExhRegistrationID : '',
                            countryId: data.data.length > 0 ? data.data[0].CountryID : ''
                        });
                        this.getDescriptionDetails();
                    }, 500);
                }
                else {
                    this.setState({ isLoading: false })
                    if (data.msg.includes('Registration completed with ')) {
                        sessionStorage.setItem("sessionExhRegistrationNo", data.msg.replace('Registration completed with ', ''))
                        this.props.navigate('/thankYou')
                    }
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    onLinkbtn1Click() {
        const { isChecBox1 } = this.state
        this.setState({ isChecBox1: !isChecBox1 })
    }
    onLinkbtn2Click() { }
    onLinkbtn3Click() { }
    onLinkbtn4Click() { }



    onCheckBoxClick(data, i) {
        const { checkboxList, isChecBox1, isChecBox3, openPop4, openPop5, isChecBox4, isChecBox5, isChecBox6, isFlag1, isFlag3, isFlag4, isFlag5, isFlag6 } = this.state
        console.log(data)
        // setTimeout(() => {
        if (data.label.includes('claims')) {
            data.checked = !data.checked
            this.setState({ isChecBox1: data.checked })
            // } else if (i == 1041) {
        } else if (data.label.includes('manufactured')) {
            data.checked = !data.checked
            this.setState({ isChecBox3: data.checked })
        } else if (data.label.includes('Rules and Regulation')) {
            if (data.checked) {
                this.setState({ isChecBox4: false })
                data.checked = !data.checked
                // this.setState({ checkboxList: checkboxList })
            } else {
                this.setState({ openPop4: !openPop4 }, async () => {
                    // render PDF after modal opens
                    await this.PdfRender();
                });
            }
        } else if (data.label.includes('undertaking')) {
            if (data.checked) {
                this.setState({ isChecBox5: false })
                data.checked = !data.checked
            } else {
                this.setState({ openPop5: !openPop5 })
            }
            // this.setState({ isChecBox5: true })
        } else if (data.label.toLowerCase().includes('email') && data.label.toLowerCase().includes('sms') && data.label.toLowerCase().includes('whatsapp')) {
            data.checked = !data.checked
            this.setState({ isChecBox6: data.checked })
        } else if (data.label.toLowerCase().includes('knowledge')) {
            data.checked = !data.checked
            this.setState({ isChecBox7: data.checked })
        }

        // this.setState({ checkboxList: checkboxList })
        setTimeout(() => {

            console.log(i, checkboxList, isChecBox1, isChecBox3, isChecBox4, isChecBox5, isChecBox6)
        }, 500);
        // }, 50);
    }

    onCheckBox2Click = async (id) => {
        const { isChecBox2, checkboxList, openPop4, openPop5 } = this.state
        if (id == 1) {
            checkboxList.map((data) => (
                // data.ExhRegistrationNotesId == 1041 ? data.checked = true : null
                data.label.includes('Rules and Regulation') ? data.checked = true : null
            ))
            this.setState({ openPop4: !openPop4, isChecBox4: true }, async () => {
                // render PDF after modal opens
                await this.PdfRender();
            });
        } else if (id == 2) {
            checkboxList.map((data) => (
                data.label.includes('undertaking') ? data.checked = true : null
            ))
            this.setState({ openPop5: !openPop5, isChecBox5: true })
        }
    }


    // onCheckBox3Click() {
    //     const { isChecBox3 } = this.state
    //     this.setState({ isChecBox3: !isChecBox3 })
    // }

    // onCheckBox4Click() {
    //     const { isChecBox4 } = this.state
    //     this.setState({ isChecBox4: !isChecBox4 })
    // }


    // get fill List dropdown  
    getFillList(actionID, exhibitionID, moduleID, keyValue, value) {
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    // country list
                    if (actionID === countryActionId) {
                        console.log("country data", data.data)
                        this.setState({
                            countryList: data.data, isLoading: false,
                        })
                    }
                    if (actionID === paymentMasterListActionId) {
                        console.log("country data", data.data)
                        this.setState({
                            paymentMasterList: data.data, isLoading: false,
                        })
                        data.data.length > 0 && data.data.map(item => {
                            item.PaymentModuleID == 2 && this.setState({ isPaymentEnable: item.IsPaymentEnable })
                        })
                    }
                    if (actionID === surchargeListActionId) {
                        console.log("country data", data.data)
                        this.setState({
                            pgViewChargesFillList: data.data, isLoading: false,
                        })
                        // data.data.length > 0 && data.data.map(item => {
                        //     item.PaymentModuleID == 2 && this.setState({ isPaymentEnable: item.IsPaymentEnable })
                        // })
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });

    }

    async getDescriptionDetails() {
        const { exhRegistrationID, exhibitionID, comment, isChecBox1, isChecBox3, isChecBox4 } = this.state

        this.setState({ isLoading: true })
        var exbid = sessionStorage.getItem("sessionExhibitionID");
        var regid = sessionStorage.getItem("sessionExhRegistrationID")

        this.props
            .getdescriptionDetails_action(regid, exbid) // DYNAMIC PARAMS HAS TO BE PLACE LATER <<==
            .then(async (data) => {
                if (data.error != 1) {
                    console.log(data.data)
                    // var tempcheckboxArr = data.data['extraDetails'][0].CheckBoxNotes.split('\n')
                    var checkboxArr = []
                    var undertakingNotes = []
                    if (data.data['extraDetails'] != undefined) {
                        for (var i = 0; i < data.data['extraDetails'].length; i++) {
                            if (data.data['extraDetails'][i].NoteType == 'Estimate Checkbox Note') {
                                var obj = {}
                                obj.label = data.data['extraDetails'][i].Description
                                obj.value = data.data['extraDetails'][i].ExhRegistrationNotesId
                                obj.checked = false
                                obj.ExhRegistrationNotesId = data.data['extraDetails'][i].ExhRegistrationNotesId
                                // if (sessionStorage.getItem("sessionContryName") != 'India ') {
                                // data.data['extraDetails'][i].ExhRegistrationNotesId == 1041 && checkboxArr.push(obj)
                                if (data.data['extraDetails'][i]['Description'].toLowerCase().includes('claims')) {
                                    if (data.data['configurationDetails'][0]['isAgreeClaim']) {
                                        checkboxArr.push(obj)
                                    }
                                }
                                if (data.data['extraDetails'][i]['Description'].toLowerCase().includes('rules and regulation')) {
                                    if (data.data['configurationDetails'][0]['isAgreeRule']) {
                                        checkboxArr.push(obj)
                                    }
                                }
                                if (data.data['extraDetails'][i]['Description'].toLowerCase().includes('manufactured')) {
                                    if (data.data['configurationDetails'][0]['isAgreeMFG']) {
                                        checkboxArr.push(obj)
                                    }
                                }
                                if (data.data['extraDetails'][i]['Description'].toLowerCase().includes('knowledge')) {
                                    if (data.data['configurationDetails'][0]['Is_AgreeInfo']) {
                                        checkboxArr.push(obj)
                                    }
                                }
                                // if (data.data['extraDetails'][i]['Description'].toLowerCase().includes('undertaking')) {
                                //     if (data.data['configurationDetails'][0]['isAgreeUndertaking']) {
                                //         checkboxArr.push(obj)
                                //     }
                                // }
                                if (data.data['extraDetails'][i]['Description'].toLowerCase().includes('email') && data.data['extraDetails'][i]['Description'].toLowerCase().includes('sms') && data.data['extraDetails'][i]['Description'].toLowerCase().includes('whatsapp')) {
                                    if (data.data['configurationDetails'][0]['isAgreeConsent']) {
                                        checkboxArr.push(obj)
                                    }
                                }

                                this.setState({
                                    isFlag1: data.data['configurationDetails'][0]['isAgreeClaim'],
                                    isFlag3: data.data['configurationDetails'][0]['isAgreeMFG'],
                                    isFlag4: data.data['configurationDetails'][0]['isAgreeRule'],
                                    isFlag5: false,
                                    isFlag6: data.data['configurationDetails'][0]['isAgreeConsent'],
                                    // isFlag7: data.data['configurationDetails'][0]['isAgreeInfo'],
                                })
                                this.setState({
                                    conversionRate: data.data['configurationDetails'][0].ConversionRate,
                                    additionalChargesUSDper: data.data['configurationDetails'][0].additionalChargesUSD,

                                })

                                // }
                                // else {
                                //     checkboxArr.push(obj)
                                // }
                            }
                            if (data.data['extraDetails'][i].NoteType == 'Estimate Note') {
                                undertakingNotes.push(data.data['extraDetails'][i].Description)
                            }
                        }
                        // else {
                        // if (sessionStorage.getItem("sessionContryName") != 'India ') {
                        //     checkboxArr.pop()
                        //     checkboxArr.pop()
                        // }

                        // }
                    }
                    console.log("id1------------>", checkboxArr)
                    for (var i = 0; i < checkboxArr.length; i++) {
                        if (checkboxArr[i].label.includes('claims')) {
                            checkboxArr[i].checked = data.data['otherDetails'][0]['Is_AgreeClaim'] != null ? data.data['otherDetails'][0]['Is_AgreeClaim'] : false
                        }
                        if (checkboxArr[i].label.includes('knowledge')) {
                            checkboxArr[i].checked = data.data['otherDetails'][0]['Is_AgreeInfo'] != null ? data.data['otherDetails'][0]['Is_AgreeInfo'] : false
                        }
                        // if (checkboxArr[i].ExhRegistrationNotesId == 1041) {
                        if (checkboxArr[i].label.includes('Rules and Regulation')) {
                            checkboxArr[i].checked = data.data['otherDetails'][0]['Is_AgreeRules'] != null ? data.data['otherDetails'][0]['Is_AgreeRules'] : false
                        }
                        if (checkboxArr[i].label.includes('manufactured')) {
                            checkboxArr[i].checked = data.data['otherDetails'][0]['Is_AgreeMFG'] != null ? data.data['otherDetails'][0]['Is_AgreeMFG'] : false
                        }
                        if (checkboxArr[i].label.includes('undertaking')) {
                            checkboxArr[i].checked = data.data['otherDetails'][0]['isAgreeUndertaking'] != null ? data.data['otherDetails'][0]['isAgreeUndertaking'] : false
                        }
                        if (checkboxArr[i].label.toLowerCase().includes('email') && checkboxArr[i].label.toLowerCase().includes('sms') && checkboxArr[i].label.toLowerCase().includes('whatsapp')) {
                            checkboxArr[i].checked = data.data['otherDetails'][0]['isAgreeConsent'] != null ? data.data['otherDetails'][0]['isAgreeConsent'] : false
                        }
                    }
                    var undertakingContent = []
                    data.data['otherDetails'][0]['UndertakingContent1'] != null && data.data['otherDetails'][0]['UndertakingContent1'] != undefined && undertakingContent.push(data.data['otherDetails'][0]['UndertakingContent1'])
                    data.data['otherDetails'][0]['UndertakingContent2'] != null && data.data['otherDetails'][0]['UndertakingContent2'] != undefined && undertakingContent.push(data.data['otherDetails'][0]['UndertakingContent2'])
                    // data.data['otherDetails'][0]['UndertakingContent3'] != null && data.data['otherDetails'][0]['UndertakingContent3'] != undefined && undertakingContent.push(data.data['otherDetails'][0]['UndertakingContent3'])
                    data.data['otherDetails'][0]['UndertakingContent5'] != null && data.data['otherDetails'][0]['UndertakingContent5'] != undefined && undertakingContent.push(data.data['otherDetails'][0]['UndertakingContent5'])
                    data.data['otherDetails'][0]['UndertakingContent4'] != null && data.data['otherDetails'][0]['UndertakingContent4'] != undefined && undertakingContent.push(data.data['otherDetails'][0]['UndertakingContent4'])
                    console.log('checkboxArr', checkboxArr)
                    var paymentArr = []
                    var paymentKeys = []
                    paymentKeys = data.data['paymentMethod'].length > 0 ? Object.keys(data.data['paymentMethod'][0]) : []
                    if (paymentKeys.length > 0 && paymentKeys.includes('BeneficiaryName')) {
                        var obj = { 'Description': 'NAME OF THE BENEFICIARY', 'Details': data.data['paymentMethod'][0].BeneficiaryName }
                        paymentArr.push(obj)
                    }
                    if (paymentKeys.length > 0 && paymentKeys.includes('CurrentAccountNo')) {
                        var obj = { 'Description': 'CURRENT ACCOUNT NO', 'Details': data.data['paymentMethod'][0].CurrentAccountNo }
                        paymentArr.push(obj)
                    }
                    if (paymentKeys.length > 0 && paymentKeys.includes('BankName') && paymentKeys.includes('BranchName')) {
                        var obj = { 'Description': 'BANK AND BRANCH', 'Details': `${data.data['paymentMethod'][0].BankName}, ${data.data['paymentMethod'][0].BranchName}` }
                        paymentArr.push(obj)
                    }
                    if (paymentKeys.length > 0 && paymentKeys.includes('SwiftCode')) {
                        var obj = { 'Description': 'SWIFTCODE', 'Details': data.data['paymentMethod'][0].SwiftCode }
                        paymentArr.push(obj)
                    }
                    if (paymentKeys.length > 0 && paymentKeys.includes('IFSCode')) {
                        var obj = { 'Description': 'IFSC Code', 'Details': data.data['paymentMethod'][0].IFSCode }
                        paymentArr.push(obj)
                    }
                    for (var i = 0; i < data.data['description'].length; i++) {
                        if (data.data['description'][i].Description.includes("--")) {
                            data.data['description'][i].Description = data.data['description'][i].Description.replace(/\n/g, ' ')
                            data.data['description'][i].Description = data.data['description'][i].Description.replace(/--/g, '\n')
                        }
                    }
                    for (var i = 0; i < data.data['description'].length; i++) {
                        if (data.data['description'][i].Description.includes("International Space")) {
                            console.log('International SpaceInternational SpaceInternational SpaceInternational SpaceInternational SpaceInternational Space')
                            this.setState({ toShowIntNotes: true })
                        }
                    }
                    // var tempDes =
                    this.setState({
                        descriptionList: data.data['description'],
                        paymentList: paymentArr,
                        checkboxList: checkboxArr,
                        undertakingContent: undertakingContent,
                        // remittancesInfavour: data.data['extraDetails'][0].RemittanceInFavour,
                        estimateDescription: data.data['estimateDetails'][0]['Estimate_Description'] != null ? data.data['estimateDetails'][0]['Estimate_Description'] : '',
                        comment: data.data['otherDetails'][0]['Comment'] != null ? data.data['otherDetails'][0]['Comment'] : '',
                        isChecBox1: data.data['otherDetails'][0]['Is_AgreeClaim'] != null ? data.data['otherDetails'][0]['Is_AgreeClaim'] : false,
                        isChecBox3: data.data['otherDetails'][0]['Is_AgreeMFG'] != null ? data.data['otherDetails'][0]['Is_AgreeMFG'] : false,
                        isChecBox4: data.data['otherDetails'][0]['Is_AgreeRules'] != null ? data.data['otherDetails'][0]['Is_AgreeRules'] : false,
                        isChecBox5: data.data['otherDetails'][0]['isAgreeUndertaking'] != null ? data.data['otherDetails'][0]['isAgreeUndertaking'] : false,
                        isChecBox6: data.data['otherDetails'][0]['isAgreeConsent'] != null ? data.data['otherDetails'][0]['isAgreeConsent'] : false,
                        isChecBox7: data.data['otherDetails'][0]['Is_AgreeInfo'] != null ? data.data['otherDetails'][0]['Is_AgreeInfo'] : false,
                        AuthorizedPersonName: data.data['otherDetails'][0]['ExhUndertakingPersonName'] != null ? data.data['otherDetails'][0]['ExhUndertakingPersonName'] : '',
                        DesignationAuthorizedPerson: data.data['otherDetails'][0]['ExhUndertakingDesignation'] != null ? data.data['otherDetails'][0]['ExhUndertakingDesignation'] : '',
                        ExhibitorCompanyName: data.data['otherDetails'][0]['ExhUndertakingCompanyName'] != null ? data.data['otherDetails'][0]['ExhUndertakingCompanyName'] : '',
                        EmailAuthorizedPerson: data.data['otherDetails'][0]['ExhUndertakingEmail'] != null ? data.data['otherDetails'][0]['ExhUndertakingEmail'] : '',
                        MobileAuthorizedPerson: data.data['otherDetails'][0]['ExhUndertakingMobileNo'] != null ? data.data['otherDetails'][0]['ExhUndertakingMobileNo'] : '',
                        RandRpath: data.data['otherDetails'][0]['RulesAndRegulations'] != null ? data.data['otherDetails'][0]['RulesAndRegulations'] : '',

                        toPay: data.data['paymentDetails'][0]['PayableAmount'] != null ? data.data['paymentDetails'][0]['PayableAmount'] : false,
                        toPaydummy: data.data['paymentDetails'][0]['PayableAmount'] != null ? data.data['paymentDetails'][0]['PayableAmount'] : false,
                        toShow: data.data['paymentDetails'][0]['PayableAmount'],
                        additionalChargesUSD: ((data.data['configurationDetails'][0].additionalChargesUSD / 100) * data.data['paymentDetails'][0]['PayableAmount']).toFixed(2),

                        minPay: data.data['paymentDetails'][0]['MinAmount'] != null ? data.data['paymentDetails'][0]['MinAmount'] : false,
                        isCustompayment: data.data['paymentDetails'][0]['isCustomPayAllowed'] != null ? data.data['paymentDetails'][0]['isCustomPayAllowed'] : false,
                        undertakingNotes: undertakingNotes
                    })
                    sessionStorage.setItem("sessionExhMailWebsite", data.data['otherDetails'][0]['ExhMailWebsite'])
                    this.getFillList(paymentMasterListActionId, exbid, '', '', '', '')
                    this.getFillList(surchargeListActionId, exbid, '', '', '', '')

                    setTimeout(() => {
                        this.setState({ isLoading: false })

                    }, 300);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    async PdfRender() {
        const { RandRpath } = this.state;
        // console.log("RandRpath--------------------------------------------->", RandRpath)
        if (!RandRpath) return;

        const container = this.pdfContainerRef.current;
        // console.log("container--------------------------------------------->", container)
        if (!container) return;

        container.innerHTML = ""; // clear old pages

        const url = `${BASE_URL.split("/api")[0]}${RandRpath}`;
        console.log("url--------------------------------------------->", url)
        try {
            const pdf = await pdfjsLib.getDocument(url).promise;
            for (let i = 1; i <= pdf.numPages; i++) {
                const page = await pdf.getPage(i);
                const viewport = page.getViewport({ scale: 1.5 });

                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");

                canvas.height = viewport.height;
                canvas.width = viewport.width;
                canvas.style.width = "100%";
                canvas.style.height = "auto";
                canvas.style.display = "block";
                canvas.style.margin = "20px auto";

                container.appendChild(canvas);
                await page.render({ canvasContext: context, viewport }).promise;
            }
        } catch (err) {
            console.error("PDF rendering error:", err);
        }
    }

    onSubmitClick() {
        const { isDecscriptionUpdate } = this.state
        if (isDecscriptionUpdate == true) {
            this.onSendUpdateDescrpData();
        } else {
            this.onSendDescrpData();
        }
    }

    onPreviewClick() {
        // e.preventDefault()
        const { exhibitionID, exhRegistrationID, toPay, conversionRate, additionalChargesUSDper, toPaydummy, minPay, isCustompayment, countryId } = this.state
        this.setState({ isLoading: true })
        this.props
            .descriptionPreview_action(exhRegistrationID)
            .then((data) => {
                if (data != null) {
                    this.setState({ isLoading: false })
                    console.log('Report data (sessionIdentifier): ', data);
                    var url = `${downloadReport}?SessionIdentifier=${data}`;

                    console.log('url just before navigate', url)
                    this.props.navigate('/lastSubmit',
                        {
                            state: {
                                geturl: url,
                                toPay: toPay,
                                conversionRate: conversionRate,
                                additionalChargesUSDper: additionalChargesUSDper,
                                // toPay: toPay,
                                minPay: minPay,
                                isCustompayment: isCustompayment
                            }
                        })
                    // setTimeout(() => {
                    //     this.props.navigate('/lastSubmit',
                    //         {
                    //             state: {
                    //                 geturl: url,

                    //             }
                    //         })
                    // }, 200);
                    // console.log('Report download url : ', url);
                    // const win = window.location.replace(url, '_blank');
                    // if (win != null) {
                    //     win.focus();
                    // }
                } else {
                    this.setState({ isLoading: false })
                    toast.error('There is some problem to download report. Please try again later!', {
                        theme: 'colored',
                        autoClose: 3000,
                        hideProgressBar: true,
                    })
                }
            })
            .catch((e) => {
                console.log(e);
                this.setState({ isLoading: false })
            });

    }

    onSubmit(e) {
        var exbid = sessionStorage.getItem("sessionExhibitionID");
        var regid = sessionStorage.getItem("sessionExhRegistrationID");

        this.setState({ isLoading: true });
        this.props
            .lastSubmitAdd_action(exbid, regid)
            .then((data) => {
                this.setState({ isLoading: false });
                if (data.error != 1) {
                    this.props.navigate("/thankYou");

                    // toastSuccess("Your space booking application has been submitted successfully.");
                } else {
                    toastError(data.msg);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    onSendDescrpData(status) {
        const { isLoading, exhibitionID, AuthorizedPersonName, AuthorizedPersonNameErr, MobileAuthorizedPerson, MobileAuthorizedPersonErr, EmailAuthorizedPerson, EmailAuthorizedPersonErr, DesignationAuthorizedPerson, DesignationAuthorizedPersonErr, ExhibitorCompanyName, ExhibitorCompanyNameErr, exhRegistrationID, comment, commentErr, isChecBox1, isChecBox2, isChecBox3, countryId, isChecBox5, isChecBox4, isChecBox6, isChecBox7 } = this.state;
        return new Promise((resolve, reject) => {

            var errMsg = false
            var mobvalidate = ''
            // if (countryId == 91) {
            mobvalidate = emailValidator(EmailAuthorizedPerson)
            emailValidator(EmailAuthorizedPerson) != '' && this.setState({ EmailAuthorizedPersonErr: emailValidator(EmailAuthorizedPerson) })
            errMsg = emailValidator(EmailAuthorizedPerson) != '' ? true : false
            if (AuthorizedPersonName == '' || AuthorizedPersonName == null) {
                this.setState({ AuthorizedPersonNameErr: 'Please enter Authorized Person Name' })
                errMsg = true
            }
            if (MobileAuthorizedPerson == '' || MobileAuthorizedPerson == null) {
                this.setState({ MobileAuthorizedPersonErr: 'Please enter Authorized Person Mobile' })
                errMsg = true
            }
            if (EmailAuthorizedPerson == '' || EmailAuthorizedPerson == null) {
                this.setState({ EmailAuthorizedPersonErr: 'Please enter Authorized Person Email' })
                errMsg = true
            }
            if (DesignationAuthorizedPerson == '' || DesignationAuthorizedPerson == null) {
                this.setState({ DesignationAuthorizedPersonErr: 'Please enter Authorized Person Designation' })
                errMsg = true
            }
            if (ExhibitorCompanyName == '' || ExhibitorCompanyName == null) {
                this.setState({ ExhibitorCompanyNameErr: 'Please enter Exhibitor Company Name' })
                errMsg = true
            }
            // }
            if (!errMsg) {
                this.setState({ isLoading: true })
                this.props
                    .descriptionAdd_action(exhibitionID, exhRegistrationID, comment, isChecBox1, isChecBox3, isChecBox4, isChecBox5, AuthorizedPersonName, DesignationAuthorizedPerson, ExhibitorCompanyName, EmailAuthorizedPerson, MobileAuthorizedPerson, isChecBox6, isChecBox7
                    )
                    .then((data) => {
                        if (data.error != 1) {
                            // console.log(data.data[0]['exhibitorID']);
                            // toastSuccess("Data saved successfully");
                            if (status == 0) {
                                this.setState({ isLoading: false })
                                this.onPreviewClick();
                            } else if (status == 1) {
                                this.setState({ isLoading: false })
                                this.onSubmit()
                            } else if (status == 2) {
                                resolve(true)
                            }

                            // this.props.navigate('/lastSubmit',
                            // {
                            //     state: {
                            //         geturl: 'https://www.google.co.in/?gfe_rd=cr&ei=js5SWM7OOKbv8weeqpKICw'
                            //     }
                            // })

                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                            reject(true)
                        }
                    })
                    .catch((e) => {
                        reject(true)
                        console.log(e);
                    });
            }
            else {
                toastError('Please enter mandatory fields')
            }

            //         }
            //         else {
            //             toastError('Enter mandatory fields')
            //         }
            //     }
            // } else {
            //     toastError('Enter mandatory fields')
            // }

        })
    }

    onSendUpdateDescrpData() {
        const { isLoading, exhibitionID, exhRegistrationID, comment, commentErr, isChecBox1, isChecBox2, isChecBox3, isChecBox4, isChecBox5 } = this.state;

        var errMsg = ''

        // if (comment) {
        //     if (errMsg != '') {
        //         toastError(errMsg)
        //         errMsg = ''
        //     } else {
        //         if (commentErr == '') {
        this.setState({ isLoading: true })
        this.props
            .descriptionUpdate_action(exhibitionID, exhRegistrationID, comment, isChecBox1, isChecBox3, isChecBox4, isChecBox5
            )
            .then((data) => {

                if (data.error != 1) {
                    console.log(data.data[0]['exhibitorID']);
                    toastSuccess("Data saved successfully");
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
        //         }
        //         else {
        //             toastError('Enter mandatory fields')
        //         }
        //     }
        // } else {
        //     toastError('Enter mandatory fields')
        // }

    }

    getTermsAndCondition() {
        const { exhRegistrationID, exhibitionID, } = this.state

        this.setState({ isLoading: true })
        this.props
            .getdescriptionTermsAndCondition_action(exhRegistrationID, exhibitionID)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        comment: data.data['Comment'],
                        // isChecBox1: data.data['Claim'],
                        //isChecBox2: data.data['paymentMethod'],
                        // isChecBox3: data.data['isMfg'],
                        isChecBox4: data.data['isRules'],

                    })
                    setTimeout(() => {
                        this.setState({ isLoading: false })
                    }, 300);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    record(list) {
        // const { isNameSort, campList } = this.state
        return (
            <table className="table table-bordered tb-action du-table">
                <thead>
                    <tr key={Math.random()}>
                        <th></th>
                        <th><b>INSTALLMENT 1 IN USD (25%) BEFORE 15.05.2023</b>  BEFORE 30.05.2023</th>
                        <th><b>INSTALLMENT 2 IN USD (75%) BEFORE 30.08.2023</b>Installment 2 in (INR OR USD) B</th>
                        <th>Total Stall charges in INR RO USD (A+B)</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        list.length > 0 ?
                            list.map((data, index) => (<tr key={Math.random()} >
                                <td>{data.others}</td>
                                <td>{data.a}</td>
                                <td>{data.b}</td>
                                <td>{Number(data.a) + Number(data.b)}</td>
                            </tr>
                            )) : <><tr><td colSpan={2} className='text-center'>Record not found</td></tr></>
                    }
                </tbody>
            </table>
        )
    }

    onPreviousClick() {
        sessionStorage.setItem("renderPage", "primaryChapter")
        this.props.navigate('/primary_chapter', { state: { is_update: true } })
    }

    preventMinus = (e) => {
        if (e.code === "Minus") {
            e.preventDefault();
        }
    };

    maxLengthCheck = (object, maxLength) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(
                0,
                object.target.maxLength
            );
        }
    };

    onPayAndSubmit() {
        const { openPaymentPop, countryId, toPaydummy, EmailAuthorizedPerson, MobileAuthorizedPerson, ExhibitorCompanyName, DesignationAuthorizedPerson, AuthorizedPersonName } = this.state
        var errMsg = false
        var mobvalidate = ''
        // if (countryId == 91) {
        mobvalidate = emailValidator(EmailAuthorizedPerson)
        emailValidator(EmailAuthorizedPerson) != '' && this.setState({ EmailAuthorizedPersonErr: emailValidator(EmailAuthorizedPerson) })
        errMsg = emailValidator(EmailAuthorizedPerson) != '' ? true : false
        if (AuthorizedPersonName == '' || AuthorizedPersonName == null) {
            this.setState({ AuthorizedPersonNameErr: 'Please enter Authorized Person Name' })
            errMsg = true
        }
        if (MobileAuthorizedPerson == '' || MobileAuthorizedPerson == null) {
            this.setState({ MobileAuthorizedPersonErr: 'Please enter Authorized Person Mobile' })
            errMsg = true
        }
        if (EmailAuthorizedPerson == '' || EmailAuthorizedPerson == null) {
            this.setState({ EmailAuthorizedPersonErr: 'Please enter Authorized Person Email' })
            errMsg = true
        }
        if (DesignationAuthorizedPerson == '' || DesignationAuthorizedPerson == null) {
            this.setState({ DesignationAuthorizedPersonErr: 'Please enter Authorized Person Designation' })
            errMsg = true
        }
        if (ExhibitorCompanyName == '' || ExhibitorCompanyName == null) {
            this.setState({ ExhibitorCompanyNameErr: 'Please enter Exhibitor Company Name' })
            errMsg = true
        }
        // }
        if (!errMsg) {
            this.setState({ openPaymentPop: !openPaymentPop })
        } else {
            toastError('Please enter mandatory fields')
        }
    }

    onPaymentTypeSelect(type) {
        const { openPaymentPop, toPaydummy } = this.state

        this.setState({ paymentType: type })
        if (type == 1) {
            this.setState({ toPay: toPaydummy, toShow: toPaydummy, additionalChargesUSD: ((this.state.additionalChargesUSDper / 100) * toPaydummy).toFixed(2) })
        }
        else if (type == 2) {
            this.setState({ customPayment: '' })
        }
    }

    navPayment(e) {
        e.preventDefault()
        const { userId, selectedPIList, minPay, proformaInv, remark, paymentType, toPay, currency, } = this.state
        var ERROR = null
        if (toPay < minPay) {
            ERROR = `Total Payment amount should be greater than ${minPay}`
        }
        console.log(ERROR)
        if (ERROR == null) {
            this.setState({ isLoading: true })
            this.onSendDescrpData(2).then(desRes => {
                var moreInfo = null
                var exbid = sessionStorage.getItem("sessionExhibitionID");
                var regid = sessionStorage.getItem("sessionExhRegistrationID")
                console.log("++++++++++++++++++++++++++++++++++", sessionStorage.getItem("sessionContryName"))
                this.props.sendPaymentForm_action(exbid, regid, sessionStorage.getItem("countryId") == 91 ? toPay : this.state.isPaidByUSD ? parseFloat(this.state.additionalChargesUSD) + parseFloat(this.state.toShow) : ((1 + (this.state.additionalChargesUSDper / 100)) * this.state.toShow).toFixed(2), sessionStorage.getItem("countryId") == 91 ? 'INR' : this.state.isPaidByUSD ? 'USD' : 'INR', [], 'estimates', moreInfo, remark, "", sessionStorage.getItem("sessionExhRegistrationNo"), sessionStorage.getItem("countryId") == 91 ? false : this.state.isPaidByUSD)
                    .then((data) => {
                        console.log(data)
                        if (data.error != 1) {
                            if (data != null) {
                                console.log("payment response : ", data)

                                // this.setState({ encPayload: data.data }, () => {
                                //     this.submitfrm.current.submit()
                                // })
                                this.setState({ paymentLink: data.data }, () => {
                                    // this.submitfrm.current.submit()
                                    // window.open(data.data, '_blank')
                                    window.location.replace(data.data)

                                })
                            }
                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError('There is some problem. Please try again later!')
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }).catch(desErr => {

            })
        }
        else {
            toastError(ERROR)
        }

    }

    togglePGCharges(mode) {
        const { scripts, GroupDetailsList, countryId, isForeignPop } = this.state
        if (mode != 2) {
            if (sessionStorage.getItem("countryId") != 91) {
                // if (countryId != 91) {
                this.setState({ isForeignPop: true })
                return
                // }
            }
            // else {
            //     for (var i = 0; i < GroupDetailsList.length; i++) {
            //         if (GroupDetailsList[i].CountryName.trim().toLowerCase() != 'india') {
            //             this.setState({ isForeignPop: true })
            //             return
            //         }
            //     }
            // }
        }
        if (sessionStorage.getItem("countryId") == 91) {
            this.setState({ pgViewChargesModal: !this.state.pgViewChargesModal, isSurchargeForceOpen: mode != 1 ? false : this.state.isSurchargeForceOpen });
        } else {
            this.setState({ pgViewAddChargesModal: !this.state.pgViewAddChargesModal, isSurchargeForceOpen: mode != 1 ? false : this.state.isSurchargeForceOpen });
        }
    }

    render() {
        const { isLoading, undertakingNotes, pgViewChargesModal, comment, commentErr, PreMobileAuthorizedPerson, isChecBox1, isChecBox2, isChecBox3, isChecBox4, isChecBox5, countryId, descriptionList, paymentList, openPop1, openPaymentPop, paymentType, customPayment, toPay, encPayload, additionalChargesUSD, additionalChargesUSDper, toShow, pgViewAddChargesModal,
            openPop2, openPop3, openPop4, estimateDescription, AuthorizedPersonName, MobileAuthorizedPerson, EmailAuthorizedPerson, ExhibitorCompanyName, DesignationAuthorizedPerson, ExhibitorCompanyNameErr, AuthorizedPersonNameErr, MobileAuthorizedPersonErr, EmailAuthorizedPersonErr, DesignationAuthorizedPersonErr, openPop5, isOpenConfirmationModal, RandRpath, isFlag1, isFlag3, isFlag4, isFlag5, isFlag6, isFlag7, isChecBox6, isChecBox7 } = this.state
        descriptionList.map(item => console.log(item))
        descriptionList.map(item => item.Description.replace(/--/g, '\n'))
        console.log(this.state.isSurchargeForceOpen)
        // var maxh=calc(100vh-200px)
        return (
            <>
                {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                {/* PAGE */}
                <div className="page">
                    <div className="page-main">
                        {!sessionStorage.getItem('sessionExhibitionID') ? (<AdminHeader isSteper={false} />) : (<Header />)}
                        <div className="row m-0">
                            {/* <div className="breadcrumb-scroll-fixed px-2"><h6 className="mb-0 p-2 text-white px-2">Description</h6></div> */}
                        </div>
                        {/* {console.log("sessionStorage.getItem()", sessionStorage.getItem("sessionContryName").toString().trim().toLowerCase())} */}
                        {/*app-content open*/}
                        <StepHeader />
                        {false ? < div
                            className="main-content app-content mt-0"
                            style={{ backgroundColor: "#ececec", height: '100vh' }}
                        >
                            <div className="side-app">
                                <div className="main-container container-fluid top-form-name">
                                    <div className="row ">
                                        <form className="needs-validation " noValidate="">
                                            <div className="form-row mt-4">
                                                <div className="form-group col-md-7 p-4 thank-box">
                                                    <div className="form-group mb-2">
                                                        <h4
                                                            className="mb-0 pt-2 pb-4 thank-top-mes"
                                                            style={{ color: "#318958" }}
                                                        >
                                                            <strong>Important Note</strong>
                                                        </h4>
                                                        <p className="mb-1 mt-1 text-center com-font">
                                                            Currently, the application and website data are undergoing reconciliation and verification.<br></br>
                                                            The new application forms will be available shortly.
                                                        </p>
                                                    </div>
                                                    <div classname="">
                                                        <div classname="mt-1 mb-4">


                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div> : <div className="main-content app-content mt-0">
                            <div className="side-app">
                                {!sessionStorage.getItem('sessionExhibitionID') ? (
                                    <div style={{ marginTop: "125px" }}>
                                        <strong style={{ fontSize: "23px" }}>Your Form Already Submitted Successfully</strong>

                                    </div>
                                ) :

                                    (<div className="page-height">
                                        <div className="main-container container-fluid pt-2 pb-2 p-0 p-md-3 second-form">
                                            <div className="row">
                                                {(sessionStorage.getItem("IA") == 0 || sessionStorage.getItem("IA") == null || sessionStorage.getItem("IA") == '') && !(JSON.parse(sessionStorage.getItem('toShowEstimates')) == false) && <strong>
                                                    {/* Estimate */}
                                                    {sessionStorage.getItem("sessionContryName").toString().trim().toLowerCase() == 'india' ? `Estimate : ${estimateDescription}` : 'Estimate'}
                                                </strong>}
                                                {(sessionStorage.getItem("IA") == 0 || sessionStorage.getItem("IA") == null || sessionStorage.getItem("IA") == '') && !(JSON.parse(sessionStorage.getItem('toShowEstimates')) == false) && <div className="table-responsive m-1">

                                                    <table
                                                        className="table table-bordered"
                                                        style={{ border: "1px solid #d8d8d8 !important" }}
                                                    >
                                                        <thead>
                                                            {/* <tr>
                                            <th style={{ width: '300px' }}>DESCRIPTION</th>
                                            <th>
                                                INSTALLMENT 1 IN USD (25%) BEFORE 15.05.2023
                                            </th>
                                            <th>
                                                INSTALLMENT 2 IN USD (75%) BEFORE 30.08.2023
                                            </th>
                                            <th style={{ width: '300px' }}>TOTAL AMOUNT</th>
                                        </tr> */}
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                descriptionList.length > 0 ?
                                                                    descriptionList.map((data, index) => (<tr key={Math.random()} >
                                                                        <td style={{ width: '300px', whiteSpace: data.Description.includes('\n') ? 'pre-line' : '' }} ><strong>{data.Description}</strong></td>
                                                                        <td style={{ textAlign: index != 0 ? 'right' : 'center' }} >{index == 0 ? <strong>{data.Installment1}</strong> : data.Installment1}</td>
                                                                        <td style={{ textAlign: index != 0 ? 'right' : 'center' }} >{index == 0 ? <strong>{data.Installment2}</strong> : data.Installment2}</td>
                                                                        <td style={{ textAlign: index != 0 ? 'right' : 'center' }} >{index == 0 ? <strong>{data.OpenSide}</strong> : data.OpenSide}</td>
                                                                        <td style={{ width: '300px', textAlign: index != 0 ? 'right' : 'center' }} >{index == 0 ? <strong>{data.Total_amt}</strong> : data.Total_amt}</td>
                                                                    </tr>
                                                                    )) :
                                                                    <>
                                                                        <tr className='text-center'><td colSpan={4} className='text-center'>Record not found</td></tr>
                                                                    </>

                                                            }

                                                        </tbody>
                                                    </table>

                                                    {/* {this.record(currentRecords)} */}

                                                </div>}
                                                {(sessionStorage.getItem("IA") == 0 || sessionStorage.getItem("IA") == null || sessionStorage.getItem("IA") == '') && !(JSON.parse(sessionStorage.getItem('toShowEstimates')) == false) && <h6>Details for Remittance</h6>}
                                                {(sessionStorage.getItem("IA") == 0 || sessionStorage.getItem("IA") == null || sessionStorage.getItem("IA") == '') && !(JSON.parse(sessionStorage.getItem('toShowEstimates')) == false) && <strong>Below Are The Payment Methods</strong>}
                                                <div className="main-container container-fluid">
                                                    {(sessionStorage.getItem("IA") == 0 || sessionStorage.getItem("IA") == null || sessionStorage.getItem("IA") == '') && !(JSON.parse(sessionStorage.getItem('toShowEstimates')) == false) && <div className="form-row mt-1">
                                                        <p className="m-0 p-1">
                                                            Please remit the funds in favour of{" "}
                                                            <strong>
                                                                "{paymentList.length > 0 ? paymentList.map(item => (item.Description == "NAME OF THE BENEFICIARY" && `${item.Details}`)) : sessionStorage.getItem("sessionExhibitionName")}". For RTGS/ NEFT
                                                                please refer details Below
                                                            </strong>
                                                        </p>
                                                        <div className="table-responsive m-1 mb-0">

                                                            <table
                                                                className="table table-bordered"
                                                                style={{ border: "1px solid #d8d8d8 !important" }}
                                                            >
                                                                <thead></thead>
                                                                <tbody>
                                                                    {
                                                                        paymentList.length > 0 ?
                                                                            paymentList.map((data, index) => (
                                                                                <tr key={Math.random()}>
                                                                                    <td>
                                                                                        <strong>{data.Description}</strong>
                                                                                    </td>
                                                                                    <td>{data.Details}</td>
                                                                                </tr>

                                                                            )) : <tr className='text-center'><td colSpan={2} className='text-center'>Record not found</td></tr>
                                                                    }

                                                                </tbody>
                                                            </table>

                                                            {/* {this.record2(currentRecords2)} */}

                                                        </div>
                                                    </div>}
                                                    <div className="form-row" style={{ marginTop: (sessionStorage.getItem("IA") == 0 || sessionStorage.getItem("IA") == null || sessionStorage.getItem("IA") == '') && '0px' }}>
                                                        <label>Remarks/Any Notes</label>
                                                        <textarea className="form-control" value={comment} maxLength={500}
                                                            onChange={e => this.setState({ comment: e.target.value, commentErr: '' })} />
                                                    </div>
                                                    {/* {undertakingNotes.length > 0 && <div className="form-row mt-2"> */}
                                                    {undertakingNotes.length > 0 && this.state.toShowIntNotes && <div className="form-row mt-3"><strong>Note:<br /></strong></div>}
                                                    {this.state.toShowIntNotes && <div className="form-row ">  {

                                                        undertakingNotes.length > 0 && undertakingNotes.map((data, i) => (
                                                            <div className='mb-1'>
                                                                {undertakingNotes.length > 1 && <strong>({i + 1})</strong>}  {data}
                                                                < br />
                                                            </div>
                                                        ))
                                                    }
                                                    </div>}

                                                    {/* </div>} */}
                                                    <hr></hr>
                                                    {this.state.undertakingContent.length > 0 && <>
                                                        <div className="form-row">
                                                            <h6 className='mb-3'><strong>Exhibitor Undertaking for {sessionStorage.getItem("sessionExhibitionName")}</strong></h6>
                                                            {this.state.undertakingContent.map((data) => (
                                                                <p className='m-1 p-0'>{data}</p>
                                                            ))}
                                                        </div>
                                                        <div className="form-row mt-2">
                                                            <div className="col-xl-4 mb-1">
                                                                <label htmlFor="validationCustom01">
                                                                    Authorized Person Name<span className="text-red">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    maxLength={100}
                                                                    className="form-control"
                                                                    value={AuthorizedPersonName}
                                                                    onChange={(e) =>
                                                                        this.setState({
                                                                            AuthorizedPersonName: e.target.value,
                                                                            AuthorizedPersonNameErr: "",
                                                                        })
                                                                    }
                                                                />
                                                                {
                                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                                        {AuthorizedPersonNameErr}
                                                                    </span>
                                                                }
                                                            </div>
                                                            <div className="col-xl-4 mb-1">
                                                                <label htmlFor="validationCustom01">
                                                                    Designation of the Authorized person<span className="text-red">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    maxLength={100}
                                                                    className="form-control"
                                                                    value={DesignationAuthorizedPerson}
                                                                    onChange={(e) =>
                                                                        this.setState({
                                                                            DesignationAuthorizedPerson: e.target.value,
                                                                            DesignationAuthorizedPersonErr: "",
                                                                        })
                                                                    }
                                                                />
                                                                {
                                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                                        {DesignationAuthorizedPersonErr}
                                                                    </span>
                                                                }
                                                            </div>
                                                            <div className="col-xl-4 mb-1">
                                                                <label htmlFor="validationCustom01">
                                                                    Exhibitor company Name<span className="text-red">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    maxLength={100}
                                                                    className="form-control"
                                                                    value={ExhibitorCompanyName}
                                                                    onChange={(e) =>
                                                                        this.setState({
                                                                            ExhibitorCompanyName: e.target.value,
                                                                            ExhibitorCompanyNameErr: "",
                                                                        })
                                                                    }
                                                                />
                                                                {
                                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                                        {ExhibitorCompanyNameErr}
                                                                    </span>
                                                                }
                                                            </div>
                                                            <div className="col-xl-4 mb-1">
                                                                <label htmlFor="validationCustom01">
                                                                    Email of the Authorized person<span className="text-red">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    maxLength={100}
                                                                    className="form-control"
                                                                    value={EmailAuthorizedPerson}
                                                                    onChange={(e) =>
                                                                        this.setState({
                                                                            EmailAuthorizedPerson: e.target.value,
                                                                            EmailAuthorizedPersonErr: "",
                                                                        })
                                                                    }
                                                                />
                                                                {
                                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                                        {EmailAuthorizedPersonErr}
                                                                    </span>
                                                                }
                                                            </div>
                                                            <div className="col-xl-4 mb-1">
                                                                <div
                                                                    // className="col-xl-3 mb-1"
                                                                    style={{ position: "relative" }}
                                                                >
                                                                    <label htmlFor="validationCustom01">
                                                                        Mobile No. of the Authorized person<span className="text-red">*</span>
                                                                    </label>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        maxLength={
                                                                            sessionStorage.getItem("countryId") === "43"
                                                                                ? 11
                                                                                : 10
                                                                        }
                                                                        value={MobileAuthorizedPerson}
                                                                        onChange={(e) =>
                                                                            this.setState({
                                                                                MobileAuthorizedPerson: e.target.value,
                                                                                MobileAuthorizedPersonErr: "",
                                                                            })
                                                                        }
                                                                        onInput={(e) => sessionStorage.getItem("countryId") == 91 ? this.maxLengthCheck(e, 10) : null}
                                                                        size={"10"}
                                                                        onKeyDown={(e) =>
                                                                            (e.keyCode === 69 || e.keyCode === 190) &&
                                                                            e.preventDefault()
                                                                        }
                                                                        onWheel={(e) => e.target.blur()}
                                                                        onKeyPress={(e) => this.preventMinus(e)}
                                                                        style={{ paddingLeft: "50px" }}
                                                                    />
                                                                    <input
                                                                        type="text"
                                                                        className="form-control-1"
                                                                        placeholder="ISD"
                                                                        value={PreMobileAuthorizedPerson}
                                                                        // disabled={isCorrespondenceDetails}
                                                                        onChange={(e) =>
                                                                            this.setState({
                                                                                PreMobileAuthorizedPerson:
                                                                                    e.target.value,
                                                                            })
                                                                        }
                                                                        // placeholder={+91}
                                                                        style={{
                                                                            width: "45px",
                                                                            position: "absolute",
                                                                            top: "25px",
                                                                            paddingLeft: "5px",
                                                                        }}
                                                                    />
                                                                    {
                                                                        <span className="text-danger text-start text-left d-block mt-1">
                                                                            {MobileAuthorizedPersonErr}
                                                                        </span>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <hr></hr>
                                                    </>
                                                    }
                                                    {console.log("this.state.checkboxList---------->", this.state.checkboxList)}
                                                    {this.state.checkboxList.length > 0 && this.state.checkboxList.map((data, i) => (
                                                        <div className="form-row mt-3">
                                                            <div >
                                                                <label className="d-flex" >
                                                                    <input type="checkbox" style={{ height: 20 }}
                                                                        name={data.ExhRegistrationNotesId}
                                                                        value={data.checked}
                                                                        checked={data.checked}
                                                                        onClick={e => this.onCheckBoxClick(data, data.ExhRegistrationNotesId)}
                                                                    />
                                                                    {/* {data.label}  {data.ExhRegistrationNotesId == 1041 ? */}
                                                                    {data.label}  {data.label.includes('Rules and Regulation') ?
                                                                        <p className='text-primary' >{" "} Click Here</p> : null
                                                                    } {data.label.includes('undertaking') ?
                                                                        <p className='text-primary' >{" "} Click Here</p> : null
                                                                    }
                                                                </label>
                                                            </div>
                                                        </div>
                                                    ))}
                                                    {/* <div className="form-row">
                                                    <div >
                                                        <label className="d-flex" >
                                                            <input type="checkbox" style={{ height: 20 }}
                                                                checked={this.state.isDescripionCheckbox}
                                                                onChange={(e) => this.setState({ isDescripionCheckbox: e.target.checked })}
                                                            />
                                                            By providing your contact details in this registration form, you agree to receive regular updates about our events and programs via email and WhatsApp. Your information will be used solely for this purpose and will not be shared with third parties. You can opt-out of these communications at any time by following the unsubscribe instructions provided in the messages.
                                                        </label>
                                                    </div>
                                                </div> */}
                                                    {/* <div className="form-row mt-3">
                                                    <label className="d-flex">
                                                        <input type="checkbox" style={{ height: 20 }}
                                                            name="checkbox1"
                                                            value={isChecBox1}
                                                            checked={isChecBox1}
                                                            // onClick={e => this.onCheckBox1Click()}
                                                        />
                                                        {/* onClick={e => this.setState({ openPop1: !openPop1 })} */}
                                                    {/* We hereby agree to indemnity the Exhibition Authority and its Office-Bearers, Steering Committee Members, Executive Director, officers, employees and members and hold them and each of them harmless from and against any and all claims arising out of the acts of the exhibitor, his agents, representatives and employees. and all contractors, erectors, delivery persons, suppliers and material persons, furnishing services, delivery work or materials at the instance of the exhibitor
                                                    </label>
                                                </div> */}
                                                    {/* <div className="form-row mt-3">
                                    <input type="checkbox" name="checkbox2"
                                        value={isChecBox2}
                                        checked={isChecBox2}
                                        onClick={e => this.onCheckBox2Click()} />
                                    <label>
                                        I have read the space
                                        booking Rules and Regulation for ITME AFRICA 2023
                                        &amp; agree to abide by them <a className='text-primary' onClick={e => this.setState({ openPop2: !openPop2 })} >{" "}Click Here</a>
                                    </label>
                                </div> */}
                                                    {/* <div className="form-row mt-2">
                                                    <label className="d-flex">
                                                        <input type="checkbox" name="checkbox4" style={{ height: 20 }}
                                                            value={isChecBox4}
                                                            checked={isChecBox4}
                                                            // onClick={e => this.onCheckBox4Click()} />
                                                        I have read the space booking Rules and Regulation for ITME AFRICA & M.E. 2023 & agree to abide by them. <a className='text-primary' onClick={e => this.setState({ openPop4: !openPop4 })} >{" "} &nbsp; Click Here</a>
                                                    </label>
                                                </div> */}
                                                    {/* {
                                                    sessionStorage.getItem("sessionContryName") == 'India ' &&
                                                    <div className="form-row mt-2">
                                                        <label className="d-flex">
                                                            <input type="checkbox" style={{ height: 20 }}
                                                                name="checkbox3"
                                                                value={isChecBox3}
                                                                checked={isChecBox3}
                                                                onClick={e => this.onCheckBox3Click()} />
                                                            We hereby confirm that exhibits in the allocated booth to us based on the National exhibitor application submitted are all manufactured in India and we are not showcasing /promoting any foreign products/brand under our company banner.
                                                        </label>
                                                    </div>
                                                } */}


                                                    <div className="mt-3 mb-3">
                                                        <button className="btn btn-previous btn-full" type="submit" onClick={e => this.onPreviousClick(e)}>
                                                            Previous
                                                        </button>
                                                        {!(JSON.parse(sessionStorage.getItem('toShowEstimates')) == false) &&
                                                            ((((isFlag1 ? isChecBox1 : true) && (isFlag3 ? isChecBox3 : true) && (isFlag4 ? isChecBox4 : true) && (isFlag5 ? isChecBox5 : true) && (isFlag6 ? isChecBox6 : true)) && sessionStorage.getItem("sessionContryName") == 'India ')
                                                                || (((isFlag1 ? isChecBox1 : true) && (isFlag3 ? isChecBox3 : true) && (isFlag4 ? isChecBox4 : true) && (isFlag5 ? isChecBox5 : true) && (isFlag6 ? isChecBox6 : true)) && sessionStorage.getItem("sessionContryName") != 'India ') ? (
                                                                    // isFlag7 ? isChecBox7 :
                                                                    true) ?
                                                                (<button className="btn btn-preview mx-2 btn-full" type="submit"
                                                                    onClick={e => this.onSendDescrpData(0)}
                                                                // onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Preview?', buttonName: 'Preview', action: 0 }, popArg: [0] })}
                                                                >
                                                                    Preview
                                                                </button>) : (<button className="btn btn-preview mx-2 bg-secondary btn-full" type="submit" onClick={e => toastError('Agree and tick all boxes points to proceed further')} >
                                                                    Preview
                                                                </button>) : (<button className="btn btn-preview mx-2 bg-secondary btn-full" type="submit" onClick={e => toastError('Agree and tick all boxes points to proceed further')} >
                                                                    Preview
                                                                </button>)
                                                            )
                                                        }
                                                        {/* { console.log("Flag-------->", (isFlag1 ? isChecBox1 : true) )}
                                                    { console.log("Flag-------->", (isFlag3 ? isChecBox3 : true) )}
                                                    { console.log("Flag-------->", (isFlag4 ? isChecBox4 : true) )}
                                                    { console.log("Flag-------->", (isFlag5 ? isChecBox5 : true) )}
                                                    { console.log("Flag-------->", (isFlag6 ? isChecBox6 : true) )} */}
                                                        {
                                                            (((isFlag1 ? isChecBox1 : true) && (isFlag3 ? isChecBox3 : true) && (isFlag4 ? isChecBox4 : true) && (isFlag5 ? isChecBox5 : true) && (isFlag6 ? isChecBox6 : true)) && {/*this.state.isDescripionCheckbox*/ } && sessionStorage.getItem("sessionContryName") == 'India '
                                                            )
                                                                || (((isFlag1 ? isChecBox1 : true) && (isFlag3 ? isChecBox3 : true) && (isFlag4 ? isChecBox4 : true) && (isFlag5 ? isChecBox5 : true) && (isFlag6 ? isChecBox6 : true)) && sessionStorage.getItem("sessionContryName") != 'India ') ? (
                                                                    // isFlag7 ? isChecBox7 : 
                                                                    true) ?
                                                                (<button className="btn btn-submit mx-2 btn-full" type="submit"
                                                                    onClick={e => this.onSendDescrpData(1)}
                                                                // onClick={() => this.setState({
                                                                //     isOpenConfirmationModal: true, confirmationObj: {
                                                                //         message: `Do you want to ${sessionStorage.getItem("countryId") == 91 && JSON.parse(sessionStorage.getItem('paidByExh')) != false &&
                                                                //             this.state.isPaymentEnable ? 'Submit and Pay later' : 'Submit'}?`, buttonName: sessionStorage.getItem("countryId") == 91 && JSON.parse(sessionStorage.getItem('paidByExh')) != false &&
                                                                //                 this.state.isPaymentEnable ? 'Submit and Pay later' : 'Submit', action: 1
                                                                //     }, popArg: [1]
                                                                // })}
                                                                >
                                                                    {
                                                                        // sessionStorage.getItem("countryId") == 91 && 
                                                                        JSON.parse(sessionStorage.getItem('paidByExh')) != false &&
                                                                            this.state.isPaymentEnable ? 'Submit and Pay later' : 'Submit'}
                                                                </button>) : (<button className="btn btn-submit mx-2 bg-secondary btn-full" type="submit" onClick={e => toastError('Agree and tick all boxes points to proceed further')} >
                                                                    {
                                                                        // sessionStorage.getItem("countryId") == 91 &&
                                                                        JSON.parse(sessionStorage.getItem('paidByExh')) != false &&
                                                                            this.state.isPaymentEnable ? 'Submit and Pay later' : 'Submit'}
                                                                </button>) : (<button className="btn btn-submit mx-2 bg-secondary btn-full" type="submit" onClick={e => toastError('Agree and tick all boxes points to proceed further')} >
                                                                    {
                                                                        // sessionStorage.getItem("countryId") == 91 &&
                                                                        JSON.parse(sessionStorage.getItem('paidByExh')) != false &&
                                                                            this.state.isPaymentEnable ? 'Submit and Pay later' : 'Submit'}
                                                                </button>)

                                                        }
                                                        {
                                                            (sessionStorage.getItem("IA") == 0 || sessionStorage.getItem("IA") == null || sessionStorage.getItem("IA") == '') &&
                                                            this.state.isPaymentEnable && {/*this.state.isDescripionCheckbox*/ } && JSON.parse(sessionStorage.getItem('paidByExh')) != false &&
                                                            // sessionStorage.getItem("sessionContryName") == 'India ' && sessionStorage.getItem("countryId") == 91 &&
                                                            ((((isFlag1 ? isChecBox1 : true) && (isFlag3 ? isChecBox3 : true) && (isFlag4 ? isChecBox4 : true) && (isFlag5 ? isChecBox5 : true) && (isFlag6 ? isChecBox6 : true))
                                                                // && sessionStorage.getItem("sessionContryName") == 'India '
                                                            )
                                                                || (((isFlag1 ? isChecBox1 : true) && (isFlag3 ? isChecBox3 : true) && (isFlag4 ? isChecBox4 : true) && (isFlag5 ? isChecBox5 : true) && (isFlag6 ? isChecBox6 : true))
                                                                    //  && sessionStorage.getItem("sessionContryName") != 'India '
                                                                )
                                                                && this.state.isDescripionCheckbox ? (
                                                                    // isFlag7 ? isChecBox7 : 
                                                                    true) ?
                                                                (<button className="btn btn-submit btn-full" type="submit"
                                                                    onClick={e => this.onPayAndSubmit()}
                                                                // onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to    Pay Now and Submit?', buttonName: '   Pay Now and Submit', action: 2 }, popArg: [] })}
                                                                >
                                                                    Pay Now and Submit
                                                                </button>) : (<button className="btn btn-submit bg-secondary btn-full" type="submit"
                                                                    onClick={e => toastError('Agree and tick all boxes points to proceed further')}
                                                                >
                                                                    Pay Now and Submit
                                                                </button>) : (<button className="btn btn-submit bg-secondary btn-full" type="submit"
                                                                    onClick={e => toastError('Agree and tick all boxes points to proceed further')}
                                                                >
                                                                    Pay Now and Submit
                                                                </button>)
                                                            )
                                                        }

                                                        {/* <button className="btn btn-aqua  m-1" type="submit" onClick={e => this.onSubmitClick()} >
                                        Submit &&
                                                        ( sessionStorage.getItem("sessionContryName") == 'India ' && isChecBox4 )&&
                                    </button> */}
                                                    </div>
                                                    <div className="bottom-height"></div>
                                                    <Footer />
                                                </div>

                                            </div>
                                        </div>
                                    </div>)
                                }
                            </div>
                        </div>}
                    </div>
                </div >

                <Modal isOpen={openPop1} onRequestClose={e => this.setState({ openPop1: !openPop1 })}>
                    <div className="modal-dialog custom_modal_dialog" style={{ left: 'left', top: '8%' }}>
                        <div className="modal-content">
                            <div className="modal-header" style={{ padding: "10px 10px" }}>
                                <h5 className="modal-title" id="termsandconLabel">
                                    <b>Terms and Conditions</b>
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body" style={{ padding: "0px 12px 9px 12px" }}>
                                <div className="form-row mt-3">

                                    <label>
                                        When backdrop is set to static, the modal will not close when clicking
                                        outside it. Click the button below to try it.
                                    </label>
                                </div>
                            </div>
                            <div className="modal-footer" style={{ padding: 3 }}>
                                <button
                                    type="button"
                                    className="btn btn-gray"
                                    data-bs-dismiss="modal"
                                    style={{ padding: "4px 15px" }}
                                    onClick={e => this.setState({ openPop1: !openPop1, isChecBox1: true })}
                                >
                                    Accept
                                </button>
                            </div>
                        </div>
                    </div>

                </Modal>

                <Modal isOpen={openPop2} onRequestClose={e => this.setState({ openPop2: !openPop2 })}>
                    <div className="modal-dialog custom_modal_dialog ">
                        <div className="modal-content">
                            <div className="modal-header" style={{ padding: "10px 10px" }}>
                                <h5 className="modal-title" id="termsandconLabel">
                                    <b>Terms and Conditions</b>
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body" style={{ padding: "0px 12px 9px 12px" }}>
                                <div className="form-row mt-3">
                                    <label>
                                        When backdrop is set to static, the modal will not close when clicking
                                        outside it. Click the button below to try it.
                                    </label>
                                </div>
                            </div>
                            <div className="modal-footer" style={{ padding: 3 }}>
                                <button
                                    type="button"
                                    className="btn btn-gray"
                                    data-bs-dismiss="modal"
                                    style={{ padding: "4px 15px" }}
                                    onClick={e => this.setState({ openPop2: !openPop2, isChecBox2: true })}
                                >
                                    Accept
                                </button>
                            </div>
                        </div>
                    </div>

                </Modal>

                <Modal isOpen={openPop3} onRequestClose={e => this.setState({ openPop3: !openPop3 })}>
                    <div className="modal-dialog custom_modal_dialog ">
                        <div className="modal-content">
                            <div className="modal-header" style={{ padding: "10px 10px" }}>
                                <h5 className="modal-title" id="termsandconLabel">
                                    <b>Terms and Conditions</b>
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body" style={{ padding: "0px 12px 9px 12px" }}>
                                <div className="form-row mt-3">

                                    <label>
                                        When backdrop is set to static, the modal will not close when clicking
                                        outside it. Click the button below to try it.
                                    </label>
                                </div>
                            </div>
                            <div className="modal-footer" style={{ padding: 3 }}>
                                <button
                                    type="button"
                                    className="btn btn-gray"
                                    data-bs-dismiss="modal"
                                    style={{ padding: "4px 15px" }}
                                    onClick={e => this.setState({ openPop3: !openPop3, isChecBox3: true })}
                                >
                                    Accept
                                </button>
                            </div>
                        </div>
                    </div>

                </Modal>
                {console.log(RandRpath)}

                <Modal isOpen={openPop4} onRequestClose={e => this.setState({ openPop4: !openPop4 })} onAfterOpen={() => this.PdfRender()}>
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-header" style={{ padding: "10px 10px" }}>
                                <h5 className="modal-title" id="termsandconLabel">
                                    <b>Rules & Regulations</b>
                                </h5>
                                <button style={{ fontSize: '16px' }}
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={e => this.setState({ openPop4: !openPop4 })}
                                />
                            </div>

                            <div className="modal-body" style={{ padding: "0px 12px 9px 12px", height: 'calc(90vh - 200px)', overflow: 'auto', overflowY: 'hidden' }}>
                                {/* <iframe
                                    id="myIframe" style={{ marginTop: '0px' }}
                                    src={`${DOC_BASE_URL + RandRpath}#toolbar=0&navpanes=0`}
                                    width="100%"
                                    height="100%"
                                    title="Bing"
                                /> */}
                                <div
                                    id="pdf-container"
                                    ref={this.pdfContainerRef}
                                    style={{
                                        width: "100%",
                                        height: "100%",       // keeps it scrollable inside card
                                        overflowY: "auto",    // ✅ allow auto scrollbar (not forced scroll)
                                        WebkitOverflowScrolling: "touch", // ✅ smooth scroll (mobile too)
                                        background: '#f5f5f5'
                                    }}
                                ></div>
                            </div>
                            <div className="form-row m-3 mt-2 mb-0 border-bottom">

                                <div className="col-md-10">
                                    <p> I have read the space booking Rules and Regulation for "{sessionStorage.getItem("sessionExhibitionName")}" & agree to abide by them.</p>
                                </div>
                                <div className="col-md-2">
                                    <button
                                        type="button"
                                        className="btn btn-gray"
                                        data-bs-dismiss="modal"
                                        style={{ padding: '4px 15px', float: 'right' }}
                                        onClick={e => this.onCheckBox2Click(1)}
                                    >
                                        Accept
                                    </button>
                                </div>


                            </div>
                            {/* <div className="modal-footer" style={{ padding: 3 }}>

                            </div> */}
                        </div>
                    </div>

                </Modal>

                <Modal isOpen={openPop5} onRequestClose={e => this.setState({ openPop5: !openPop5 })}>
                    <div className="modal-dialog custom_modal_dialog" style={{ left: '0px', top: '50px' }}>
                        <div className="modal-content">
                            <div className="modal-header" style={{ padding: "7px 10px" }}>
                                <h5 className="modal-title" id="termsandconLabel">
                                    <b>Undertaking</b>
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body" style={{ padding: "0px 12px 9px 12px" }}>
                                <iframe
                                    id="myIframe" style={{ marginTop: '0px' }}
                                    src={`files/${sessionStorage.getItem("sessionExhibitionID")}/Undertaking.pdf#toolbar=0&navpanes=0`}
                                    width="1000px"
                                    height="435px"
                                    title="Bing"
                                />
                                <div className="form-row mt-3">

                                    <div className="col-md-10">
                                        <p> I have read the Undertaking for "{sessionStorage.getItem("sessionExhibitionName")}" & agree to abide by it.</p>
                                    </div>
                                    <div className="col-md-2">
                                        <button
                                            type="button"
                                            className="btn btn-gray"
                                            data-bs-dismiss="modal"
                                            style={{ padding: '4px 15px', float: 'right' }}
                                            onClick={e => this.onCheckBox2Click(2)}
                                        >
                                            Accept
                                        </button>
                                    </div>


                                </div>
                            </div>
                            {/* <div className="modal-footer" style={{ padding: 3 }}>

                            </div> */}
                        </div>
                    </div>

                </Modal>

                <Modal isOpen={openPaymentPop} onRequestClose={() => this.setState({ openPaymentPop: false })}>
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-3">
                                <h5 class="modal-title modal_title_text text-Primary">Payment</h5>
                                <button
                                    type="button"
                                    className="btn-close mr-3"
                                    data-bs-dismiss="modal"
                                    style={{ fontSize: 12 }}
                                    aria-label="Close"
                                    onClick={(e) => this.setState({ openPaymentPop: false, toPay: this.state.toPaydummy, paymentType: 1, customPayment: '', toShow: this.state.toPaydummy, additionalChargesUSD: ((this.state.additionalChargesUSDper / 100) * this.state.toPaydummy).toFixed(2) })}
                                />
                            </div>
                            <div className="row m-3" >
                                <div style={{ textAlign: 'left', fontWeight: '500', fontSize: '18px' }} className="col-md-6">
                                    <input type="radio" style={{ width: '18px', height: '18px' }}
                                        value={paymentType}
                                        checked={paymentType == 1}
                                        onClick={(e) => this.onPaymentTypeSelect(1)}
                                    />
                                    Full Payment
                                </div>
                                <div style={{ textAlign: 'left', fontWeight: '500', fontSize: '18px' }} className="col-md-6">
                                    <input type="radio" style={{ width: '18px', height: '18px' }}
                                        value={paymentType}
                                        // disabled={this.state.isCustompayment != 1}
                                        checked={paymentType == 2}
                                        onClick={(e) => this.onPaymentTypeSelect(2)}
                                    />
                                    Custom Payment
                                    {paymentType == 2 && <input type="number" className="form-control"
                                        value={customPayment}
                                        // checked={generatePriorityNoType == 1}
                                        onChange={(e) => this.setState({ customPayment: e.target.value, toPay: e.target.value == '' ? 0 : e.target.value, toShow: e.target.value == '' ? 0 : e.target.value, additionalChargesUSD: ((this.state.additionalChargesUSDper / 100) * e.target.value).toFixed(2) })}
                                    />}
                                </div>
                                <div className="mb-2" >
                                    <div style={{ textAlign: 'left', padding: 0 }} className="col-md-12 mt-2">
                                        <label>Remark</label>
                                        <textarea value={this.state.remark} className="form-control" onChange={(e) => this.setState({ remark: e.target.value })}>

                                        </textarea>
                                    </div>
                                </div>
                                {/* <p className='mt-2 text-danger'><strong>Please note that bank charges alongwith GST will be applicable as per selected mode of payment in the next step (<a className='text-primary' onClick={() => this.togglePGCharges()} style={{ cursor: 'pointer' }}>View charges</a>) </strong></p> */}
                            </div>
                            <div class="modal-footer p-1" style={{ justifyContent: 'normal' }}>
                                <div style={{ textAlign: 'left', fontWeight: '500', fontSize: '22px', padding: '0', float: 'left', left: '0' }} className="col-8 ms-2">
                                    Total: {toPay}
                                </div>
                                {/* <div className="row" > */}
                                <div className=" mt-1 col-3">
                                    {/* {this.state.isSurchargeForceOpen ? <div style={{ float: 'right' }} className="mt-1 mb-1 mr-3 "> */}
                                    {true ? <div style={{ float: 'right' }} className="mt-1 mb-1 mr-3 ">
                                        {/* <form
                                            onSubmit={(e) => this.state.isSurchargeForceOpen ? this.togglePGCharges() : this.navPayment(e)}
                                            ref={this.submitfrm}
                                            id="nonseamless" method="post" name="redirect"
                                            action={this.state.paymentLink}
                                        > */}

                                        {/* <input type="hidden" id="encRequest" name="encRequest"
                                                value={encPayload}
                                            /> */}
                                        {/* <input type="hidden" name="access_code" id="access_code"
                                                value={paymentAccessCode}
                                            /> */}
                                        <button className="btn btn-submit btn-full rounded-1"
                                            onClick={(e) => this.togglePGCharges(1)}

                                            disabled={toPay <= 0 || toPay == '' || toPay == null || paymentType == ''} style={{ border: 'none', borderRadius: '2px', scale: '1.2' }}>
                                            {/* <span style={{ color: 'black', padding: "4px 20px", fontWeight: 500, }}> */}
                                            pay
                                            {/* </span> */}
                                            {/* {!isPaid && isCarParking == 1 ? 'Make Payment' : 'Update'} */}

                                        </button>
                                        {/* </form> */}
                                    </div> :
                                        <div style={{ float: 'right' }} className="mt-1 mb-1 mr-3 ">
                                            <form
                                                onSubmit={(e) => this.navPayment(e)}
                                                ref={this.submitfrm}
                                                id="nonseamless" method="post" name="redirect"
                                                action={this.state.paymentLink}
                                            >
                                                <button className="btn btn-submit btn-full rounded-1" disabled={toPay <= 0 || toPay == '' || toPay == null || paymentType == ''} style={{ border: 'none', borderRadius: '2px', scale: '1.2' }}>
                                                    {/* <span style={{ color: 'black', padding: "4px 20px", color:'white',fontWeight: 500, }}> */}
                                                    pay
                                                    {/* </span> */}
                                                </button>
                                            </form>
                                        </div>}
                                </div>
                                {/* </div> */}
                            </div>

                        </div>
                    </div>
                </Modal >
                <Modal
                    isOpen={pgViewChargesModal}
                    onRequestClose={() => this.setState({ pgViewChargesModal: false })}
                    style={{
                        content: {
                            top: "300px",
                            // maxHeight: "calc(100vh - 220px)",
                        }
                    }}
                >
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '120px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-header p-3">
                                <h4 className="mb-0 pt-2 text-success text-center fw-bold w-100">
                                    Bank Charges
                                </h4>
                            </div>
                            <div className="row m-3" >
                                <p className='mt-2 text-danger'><strong>Please note that bank charges alongwith GST as per the below table will be applicable as per selected mode of payment in the next step </strong></p>
                                <table className="table table-bordered table-striped mg-b-0">
                                    <thead>
                                        <tr>
                                            <th>Payment Mode</th>
                                            <th>Bank Charges</th>
                                        </tr>
                                    </thead>
                                    <tbody id="myTable">
                                        {this.state.pgViewChargesFillList.length > 0 ? (
                                            this.state.pgViewChargesFillList.map((data, i) => (
                                                <tr key={i}>
                                                    <td className={data.isParent ? 'fw-bold' : ""}>{data.Description}</td>
                                                    <td>{data.Value}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <>
                                                <tr>
                                                    <td colSpan={6}>No Records Found...</td>
                                                </tr>
                                            </>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="modal-footer p-2 d-flex justify-content-end">
                                {/* {this.state.isSurchargeForceOpen && <div className=" mt-1 col-3"> */}
                                {true && <div className=" mt-1 col-3">
                                    <div style={{ float: 'right' }} className="mt-1 mb-1 mr-3 ">
                                        <form
                                            onSubmit={(e) => this.navPayment(e)}
                                            ref={this.submitfrm}
                                            id="nonseamless" method="post" name="redirect"
                                            action={this.state.paymentLink}
                                        >

                                            {/* <input type="hidden" id="encRequest" name="encRequest"
                                                value={encPayload}
                                            /> */}
                                            {/* <input type="hidden" name="access_code" id="access_code"
                                                value={paymentAccessCode}
                                            /> */}
                                            <button className="btn btn-submit btn-full rounded-1" disabled={toPay <= 0 || toPay == '' || toPay == null || paymentType == ''} style={{ border: 'none', borderRadius: '2px', scale: '1.2', marginRight: '10px' }}>
                                                {/* <span style={{ color: 'black', padding: "4px 20px", fontWeight: 500, }}> */}
                                                I agree and proceed to pay
                                                {/* </span> */}
                                                {/* {!isPaid && isCarParking == 1 ? 'Make Payment' : 'Update'} */}

                                            </button>
                                        </form>
                                    </div>
                                </div>}
                                <button
                                    className="btn btn-danger rounded-1"
                                    onClick={() => this.togglePGCharges(2)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal
                    isOpen={pgViewAddChargesModal}
                    onRequestClose={() => this.setState({ pgViewAddChargesModal: false })}
                    style={{
                        content: {
                            top: "300px",
                            // maxHeight: "calc(100vh - 220px)",
                        }
                    }}
                >
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '120px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-header p-3">
                                <h4 className="mb-0 pt-2 text-white text-center fw-bold w-100">
                                    Additional Charges
                                </h4>
                            </div>
                            <div className="row mb-3" >
                                <div className="containerfluid m-0  px-3 ">
                                    <div className="row ">
                                        <div className="col-md-12">
                                            <div className="p-1 title-bg d-flex ps-3">
                                                <p className="mb-0">
                                                    Choose Payment Currency<span className="text-red">*</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row ms-3" >
                                    <div className="col-sm-4 mt-3" >
                                        <label className="d-flex">
                                            <input type="radio" name="paidBy" value={this.state.isPaidByUSD}
                                                checked={this.state.isPaidByUSD}
                                                // onChange={e => this.setState({ attendeeType: "Business Visitor" })} 
                                                onChange={(e) => this.setState({ isPaidByUSD: true, toShow: toPay })}
                                            />
                                            Pay in USD ($)
                                        </label>
                                    </div>
                                    <div className="col-sm-4 mt-3" >
                                        <label className="d-flex">
                                            <input type="radio" name="paidBy" value={!this.state.isPaidByUSD}
                                                checked={!this.state.isPaidByUSD}
                                                // onChange={e => this.setState({ attendeeType: "Business Visitor" })} 
                                                onChange={(e) => this.setState({ isPaidByUSD: false, toShow: (toPay * this.state.conversionRate).toFixed(2) })}
                                            />
                                            Pay in INR (₹)
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="row m-3" >
                                {/* <p className='mt-2 text-danger'><strong>Please note that bank charges alongwith GST as per the below table will be applicable as per selected mode of payment in the next step </strong></p> */}
                                {/* <>“”</> */}
                                <div className="row mb-2">
                                    <div className="d-flex justify-content-between mb-2">
                                        <h5 className="mb-0">Visitor Registration Charges</h5>
                                        <h5 className="mb-0">{this.state.isPaidByUSD ? '$' : '₹'}{this.state.toShow}</h5>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="d-flex justify-content-between mb-2">
                                        <h5 className="mb-0">Additional charges ({this.state.additionalChargesUSDper}%)</h5>
                                        <h5 className="mb-0">{this.state.isPaidByUSD ? '$' : '₹'}{this.state.isPaidByUSD ? (this.state.additionalChargesUSD) : ((this.state.additionalChargesUSDper / 100) * this.state.toShow).toFixed(2)}</h5>
                                    </div>
                                </div>
                                {this.state.IGST != 0 && (
                                    <div className="row mb-2">
                                        <div className="d-flex justify-content-between mb-2">
                                            <h5 className="mb-0">Total Payable</h5>
                                            <h5 className="mb-0">{this.state.isPaidByUSD ? '$' : '₹'}{this.state.isPaidByUSD ? parseFloat(this.state.additionalChargesUSD) + parseFloat(this.state.toShow) : ((1 + (this.state.additionalChargesUSDper / 100)) * this.state.toShow).toFixed(2)}</h5>
                                        </div>
                                    </div>
                                )}
                                <p className='mt-2 '><strong>Kindly note that an additional {this.state.additionalChargesUSDper}% charge towards currency conversion will be applicable at the time of final payment as you proceed to the payment gateway.</strong></p>
                            </div>
                            <div className="modal-footer p-2 d-flex justify-content-end">
                                {/* {this.state.isSurchargeForceOpen && <div className=" mt-1 col-3"> */}
                                {true && <div className=" mt-1">
                                    <div style={{ float: 'right' }} className="mt-1 mb-1 mr-3 ">
                                        <form onSubmit={(e) => this.onPreviewSubmit(e)} ref={this.submitfrm} id="nonseamless" method="post" name="redirect"
                                            // action={paymentPortalLink}
                                            className="pay-btn-form"
                                            action={this.state.paymentLink}

                                        >

                                            {/* <input type="hidden" id="encRequest" name="encRequest"
                                                                        value={encPayload} />
                                                                    <input type="hidden" name="access_code" id="access_code"
                                                                        value={paymentAccessCode} /> */}
                                            <button type="btn" class="btn btn-aqua">
                                                I agree and proceed to pay

                                            </button>
                                        </form>
                                    </div>
                                </div>}
                                <button
                                    className="btn btn-danger rounded-1"
                                    onClick={() => this.togglePGCharges(2)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={this.state.isForeignPop} >
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title modal_title_text text-Primary"></h5>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <strong>
                                        Payments can currently be made only using Visa, Master Card, and RuPay cards issued by non-Indian banks.
                                    </strong>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" className="btn btn-aqua"
                                        onClick={() => {
                                            this.togglePGCharges(2)
                                            this.setState({ isForeignPop: false })
                                        }
                                        }
                                    >Ok</button>
                                    <button type="button" className="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isForeignPop: false })}
                                    >Close</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal >
            </>
        );
    }
}

export default withRouter(connect(null, {
    fill_action, getdescriptionDetails_action, descriptionAdd_action, descriptionUpdate_action, getdescriptionTermsAndCondition_action,
    descriptionPreview_action, getPendingRegDetails_action, lastSubmitAdd_action, sendPaymentForm_action
})(Description));

